/**
 * Detects a 403 STEP_UP_REQUIRED response and returns the action name.
 * These errors are mapped into the STEP_UP_REQUIRED error code by the
 * StepUpGuard so the UI can prompt for re-authentication.
 */
export const isStepUpRequired = (error, fallbackAction) => {
    if (!error) return null;
    if (parseApiError(error).code === ErrorCode.STEP_UP_REQUIRED) {
        return { action: parseApiError(error).details?.action || parseApiError(error).apiError?.action || error.response?.data?.action || fallbackAction };
    }
    if (error.code === 'STEP_UP_REQUIRED') {
        return { action: fallbackAction };
    }
    return null;
};

/**
 * Standard Axios error shape used across the app.
 * Uses duck-typing instead of direct axios import { parseApiError } from '../../../common/errors/api-error';
import { ErrorCode } from '../../../common/errors/error-codes';
import to keep axios confined to api layer.
 */
export const isAxiosError = (error) => {
    return Boolean(error && (error.isAxiosError || (error.response && error.config)));
};

export default {
    isStepUpRequired,
    isAxiosError,
};